class ProductPackFormV5 extends HTMLElement {
  constructor() {
    super();
    this.packs = this.querySelectorAll('.new-pack-container');
    this.addPackToCartBtn = this.querySelector('#pack-form-atc');
    this.addPackToCartBtnCompare = this.querySelector('#pack-form-atc .new-pack-compare');
    this.addPackToCartBtnPrice = this.querySelector('#pack-form-atc .new-pack-price');
    this.activeMessage = this.querySelector('.new-pack-active-message');
    this.discountedPricesContainer = document.querySelector('.discounted-prices-container');
    this.priceSaleTag = document.querySelector('.price-sale-tag');
    this.soPrice = document.querySelector('#so-price');
    this.compareAtPriceClassic = document.querySelector('.product-cont-header2 ul.inline-list.product-meta li');
    this.badgeSavePrice = document.querySelector('.product-meta .show-saved-amount-true');
    this.reduction = this.dataset.reduction;
    this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  }

  connectedCallback() {
    this.packs.forEach((pack) => {
      pack.addEventListener('click', () => {
        this.setActivePack(pack);
      });
    });

    this.addPackToCartBtn.addEventListener('click', () => {
      this.addPackToCart();
    });
  }

  setActivePack(pack) {
    this.packs.forEach((p) => {
      p.classList.remove('new-pack--active');
    });
    pack.classList.add('new-pack--active');

    this.toggleHideDiscountedPrices(pack);
    this.setButtonPrices(pack);
    this.setActiveMessage(pack);
  }

  toggleHideDiscountedPrices(pack) {
    const originalPrice = document.querySelector('.price--block');
    const discountedPrice = document.querySelector('.price--discounted');

    if (!discountedPrice) return;

    if (pack.dataset.additionalProduct == 'false') {
      if (pack.dataset.qty === '1') {
        originalPrice.classList.remove('hidden');
        discountedPrice.classList.add('hidden');
      } else {
        originalPrice.classList.add('hidden');
        discountedPrice.classList.remove('hidden');
      }
    } else {
      originalPrice.classList.add('hidden');
      discountedPrice.classList.remove('hidden');
    }
  }

  setActiveMessage(pack) {
    this.activeMessage.innerHTML = pack.dataset.activeMessage;
  }

  setButtonPrices(pack) {
    this.addPackToCartBtnCompare.textContent =
      pack.dataset.shownCompare != pack.dataset.shownPrice ? pack.dataset.shownCompare : '';
    this.addPackToCartBtnPrice.textContent = pack.dataset.shownPrice;
  }

  getActivePack() {
    return this.querySelector('.new-pack--active');
  }

  addPackToCart() {
    const activePack = this.getActivePack();
    let formData;
    const parseQuantity = (value, defaultValue = 1) => parseInt(value || defaultValue, 10);

    if (this.dataset.ids != null && activePack.dataset.additionalProduct == 'true') {
      const idsToAdd = this.dataset.ids.split(',');
      const extraQty = parseInt(this.dataset.extraAdditionalQty || '1');
      formData = {
        items: [],
        sections_url: window.location.pathname,
      };
      idsToAdd.forEach((id, i) => {
        console.log(i);
        let finalQuantity;
        if (i === 0) {
          finalQuantity = parseQuantity(activePack.dataset.qty);
        } else if (i === 1) {
          finalQuantity = parseQuantity(activePack.dataset.additionalProductQty);
        } else if (i === 2) {
          finalQuantity = parseQuantity(activePack.dataset.extraAdditionalQty);
        } else {
          finalQuantity = parseQuantity(activePack.dataset.qty); // Par défaut
        }
        console.log(finalQuantity);
        formData.items.unshift({
          id: id.trim(), // Assurez-vous de supprimer les espaces blancs éventuels
          quantity: finalQuantity, // Vous pouvez ajuster la quantité selon vos besoins
        });
      });
    } else if (this.dataset.idsThird != null && activePack.dataset.additionalProductThird == 'true') {
      const idsToAdd = this.dataset.idsThird.split(',');
      formData = {
        items: [],
        sections_url: window.location.pathname,
      };
      idsToAdd.forEach((id, i) => {
        let finalQuantity;
        if (i === 0) {
          finalQuantity = parseQuantity(activePack.dataset.qty);
        } else if (i === 1) {
          finalQuantity = parseQuantity(activePack.dataset.additionalProductQty);
        } else if (i === 2) {
          finalQuantity = parseQuantity(activePack.dataset.extraAdditionalQty);
        } else {
          finalQuantity = parseQuantity(activePack.dataset.qty); // Par défaut
        }
        formData.items.unshift({
          id: id.trim(), // Assurez-vous de supprimer les espaces blancs éventuels
          quantity: finalQuantity, // Vous pouvez ajuster la quantité selon vos besoins
        });
      });
    } else {
      formData = {
        items: [
          {
            id: this.dataset.id,
            quantity: activePack.dataset.qty,
          },
        ],
        sections_url: window.location.pathname,
      };
    }
    if (this.cart) {
      formData = {
        ...formData,
        sections: this.cart.getSectionsToRender().map((section) => section.id),
      };
    }

    if (this.cart) this.cart.setActiveElement(document.activeElement);

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData),
    })
      .then((response) => response.json())
      .then((response) => {
        if (!this.cart) {
          window.location = window.routes.cart_url;
          return;
        }

        setTimeout(async () => {
          console.log(response);
          await this.cart.renderContents(response);
        });
      })
      .catch((error) => {
        console.error('Error:', error);
      })
      .finally(() => {
        if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
      });
  }
}

customElements.define('product-pack-form-v5', ProductPackFormV5);
